// eslint-disable-next-line import/prefer-default-export
export const makeQueryKey = (search: string): string => `${search}`;
